import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import '../assets/style/index.css';


const ConfirmationPage = () => {
	const location = useLocation();

  // Récupérer l’email passé via navigation
  const emailUtilisateur = location.state?.email;
	const sendEmail = () => {
		if (!emailUtilisateur) {
				alert('Impossible d\'envoyer le mail : adresse non disponible.');
				return;
			  }
			
    axios.post('https://ekapi.bblconcept.com/sendMail.php', new URLSearchParams({ email: emailUtilisateur }))
      .then(res => alert(res.data.message))
      .catch(err => alert('Erreur lors de l\'envoi'));
  };
	const [showMessage, setShowMessage] = useState(true);
	useEffect(() => {
    // Après 5 secondes, cacher le message
    const timer = setTimeout(() => {
      setShowMessage(false);
    }, 5000);
    return () => clearTimeout(timer); // nettoyage
  }, []);
   return (
   
    <div className="container text-center my-5">
	<div className="text-center">
	  
		<img src="logo2.jpg" className="logoConnexion" alt="Logo"/>
	</div>
    <div className="alert alert-success position-relative p-5 animate__animated animate__fadeIn" style={{ fontSize: '1.5em', borderRadius: '15px' }}>
        {/* Icône coche avec animation pulse */}
        <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '80px', animation: 'pulse 2s infinite' }}></i>
        <h2 className="mt-3">Votre souscription est validée !</h2>
        <p className="lead">Cliquez sur le lien dans votre email pour confirmer votre inscription.</p>
		<div className="d-flex justify-content-between mt-3">
			
			<Link to="/Login" className="btn btn-info">Se connecter</Link>
		</div>
      </div>
    </div>
  );
};

export default ConfirmationPage;

